import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import SpecificationViewed from "../../component/SepcificationViewed";
import FilePdf from "../../broucherPdf/filePdf";
import uvlaser from "../../assets/uvlaserprofile.png";

export default function UspUvLaser() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Case / Stand Material",
      data: "Anodized Aluminum",
    },
    {
      title: "Laser Wavelength & Marking Method",
      data: "355nm & High-Precision 2-Dimensional Scanning",
    },
    {
      title: "Barcode / QR Code",
      data: "CODE39 / CODE128 / code126 / QR code / Z-code / DM code",
    },
    {
      title: "Control System",
      data: "10 inch touch screen",
    },
    {
      title: "Type of Marking Line",
      data: "Dot Matrix and Vector Format",
    },
    {
      title: "Cooling System",
      data: "Water-cooled system",
    },
  ];
  const rightSidePrinterSpecification = [
    {
      title: "Laser Type",
      data: "UV Laser Source",
    },
    {
      title: "Galvanometer Scanner",
      data: "SQUID INK",
    },
    {
      title: "Line Speed",
      data: "<=12000mm/s",
    },
    {
      title: "Operating System",
      data: "WIN CE",
    },
    {
      title: "Positioning Range",
      data: "REd Light positioning, auto focus",
    },
    {
      title: "Reflector Size",
      data: "Standard : 8mm",
    },
  ];
  const foodAndBeverage1 = [
    {
      productImg: Images?.industry6,
      label: "Personal care",
      pageNavigate: "/byindustry/personalCare",
    },
    {
      productImg: Images?.industry4,
      label: "Electrical",
      pageNavigate: "/byindustry/electrical",
    },
    {
      productImg: Images?.industry8,
      label: "Telecom & Infrastructure",
      pageNavigate: "/byindustry/telecom",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };
  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="USP UV LASER"
        printerImg={Images?.uspstream19}
        pdfFile={FilePdf?.usp_UVLaser}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            UV LASER CODING SYSTEM
          </header>
          <div
            ref={printerDetailsRef}
            // className="printerDetailsData"
            className={`printerDetailsData ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            Squid Laser Marking Software has been designed and developed by
            highly specialized team, consolidating the marked requests in the
            long term marking know how in marking industry. Versatile in the
            applications and friendly to use, even by operators without highly
            technical specific training, such as CAD knowledge. It mainly
            applied for the industries of pharmaceutical, chemical for daily,
            food & Beverage, cable, pipe and electronics.
          </div>
          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                // className={`youtubeVideo `}
                className={`youtubeVideo ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div className="productImageContainer">
                    <img className="w-[100%]" src={uvlaser} alt="" />
                  </div>
                  {/* Buttons */}
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.usp_UVLaser}
                    download="Usp UV LASER"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
